import React, { PureComponent } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ReactComponent as IconChevronRight } from '../../../assets/svg/chevron-right.svg';
import { CATEGORIES, TIMETABLES_ACTION, logEvent } from '../../../services/AnalyticsService';

export default class SchoolBusButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };


  _createRedirectLink = () => {
    let host = _.get(window, 'location.hostname');
    if (host === 'localhost' || host === '127.0.0.1') {
      host = 'test.at.govt.nz';
    }
    return host ? `https://${host}/bus-train-ferry/timetables/school-timetables/` : null;
  };

  _logClick = () => {
    logEvent(CATEGORIES.TIMETABLES, TIMETABLES_ACTION.SCHOOL_BUS, 'School bus timetable link selected');
  };

  render() {
    const { className } = this.props;
    return (
      <div className={`school-bus-button ${className}`}>
        <div className="school-bus-button__separator" />
        <div className="school-bus-button__content">
          <p className="link">
            <a className="at-btn at-btn--borderless at-btn--dark" href={this._createRedirectLink()} onClick={this._logClick}>
              View school bus timetables
              <IconChevronRight className="school-bus-button__content__icon" role="img" aria-hidden="true" focusable="false" />
            </a>
          </p>
        </div>
      </div>
    );
  }
}